import type { IconSvgObject } from './types';

const LowSignalIcon: IconSvgObject = [
  ["path", { d: "M17 19V5H20V19H17Z", stroke: "currentColor", strokeLinecap: "round", strokeLinejoin: "round", strokeWidth: "1.5", key: "0" }],
  ["path", { d: "M10.5 19V8H13.5V19H10.5Z", stroke: "currentColor", strokeLinecap: "round", strokeLinejoin: "round", strokeWidth: "1.5", key: "1" }],
  ["path", { d: "M5.5 12H4V19H5.5M5.5 12H7V19H5.5M5.5 12V19", stroke: "currentColor", strokeLinecap: "round", strokeLinejoin: "round", strokeWidth: "1.5", key: "2" }]
];

export default LowSignalIcon;
